import { Link } from "react-router-dom";
import { ArrowRight, Shield } from "lucide-react";
import { services } from "../data/services";
import { getHead } from "../seo/routes";
import { Seo } from "../components/Seo";
import { PageHero, CTABand } from "../components/Blocks";
import { IconTile, SERVICE_ICONS } from "../components/Icons";

const head = getHead("/services");

export default function ServicesIndex() {
  return (
    <>
      <Seo title={head.title} description={head.description} path="/services" />
      <PageHero
        overline="Full Service Line"
        title="Professional Security Services in Canada"
        lead="Twenty specialized security guard services, delivered by provincially licensed personnel with verified reporting — available in every province, territory and major Canadian city."
      />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="services-directory">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s) => (
            <Link
              key={s.slug}
              to={`/services/${s.slug}`}
              data-testid={`services-page-card-${s.slug}`}
              className="group border border-white/10 bg-[#181C28] rounded-sm overflow-hidden transition-all duration-200 hover:-translate-y-1 hover:border-[#FF5500]/50 hover:shadow-[0_10px_30px_rgba(255,85,0,0.15)]"
            >
              <IconTile icon={SERVICE_ICONS[s.slug] || Shield} className="h-36 border-b border-white/10" />
              <div className="p-5">
                <h2 className="font-display text-lg font-bold uppercase tracking-tight text-white group-hover:text-[#FF5500] transition-colors">{s.name}</h2>
                <p className="mt-2 text-sm text-gray-400 leading-relaxed">{s.short}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-mono uppercase tracking-wider text-[#FF5500]">
                  View service <ArrowRight className="h-3 w-3" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>
      <CTABand title="Not Sure Which Service Fits?" sub="Describe your property and risk to our dispatch team — we'll recommend the right coverage and start with a site walk-through." />
    </>
  );
}
